import { createAppLayout } from '@mono-activities/hooks'
import { MutableRefObject } from 'react'

export type AppLayoutContextType = {
  root: MutableRefObject<HTMLDivElement | null>
  footerCenter: MutableRefObject<HTMLDivElement | null>
  footerRight: MutableRefObject<HTMLDivElement | null>
}

const { AppLayoutContext, AppLayoutProvider, useAppLayout } = createAppLayout<AppLayoutContextType>()

export { AppLayoutContext, useAppLayout }
export default AppLayoutProvider
